
import Confirm from '@/components/confirm/confirm.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Previewer from 'vux/src/components/previewer/index.vue'
import Popup from 'vux/src/components/popup/index.vue'


export default {
name: 'handleReply',
directives: {
TransferDom
},
components: {
'Confirm': Confirm,
Previewer,
Popup
},
data () {
return {
listIndex: 1,
list: [{ src: '' }],
options: {
getThumbBoundsFn (index) {
let thumbnail = document.querySelectorAll('.info-img')[index]
let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
let rect = thumbnail.getBoundingClientRect()
return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
}
},
isConfirmshow: false,
confirmtitle: '',
confirmconten: '',
item: {},
handleType: 0
}
},
created () {
this.getDetail()
},
methods: {
getDetail () {
var params = new URLSearchParams()
params.append('appealId', this.$route.query.id)
this.$http({
method: 'post',
url: '/workorder/loginPwdAppeal/detail',
params: params
}).then(res => {
this.item = res.result
this.list[0].src = res.result.logopath
}).catch(error => {
console.log(error)
})
},
logIndexChange (arg) {
console.log(arg)
},
show (index) {
this.$refs.previewer.show(index)
},
handleswipe (type) {
this.handleType = type
switch (type) {
case 1:
this.confirmtitle = '通过密码申诉'
this.confirmconten = '是否确认通过用户（' + this.item.appealusername + '）的密码申诉，通过后会将该学生密码修改生成 8 位随机密码，并发送到当前学生填写手机号！'
break
case 2:
this.confirmtitle = '拒绝密码申诉'
this.confirmconten = '拒绝申诉请求后将会通过短信方式发送申诉失败提醒至学生手机。是否确认拒绝该用户的申诉请求？'
break
}
this.isConfirmshow = true
},
confirm () {
var params = new URLSearchParams()
params.append('id', this.$route.query.id)
if (this.handleType === 1) {
this.$http({
method: 'post',
url: '/workorder/loginPwdAppeal/passcheck',
params: params
}).then(res => {
if (res.success) {
this.$vux.toast.text('操作成功，已通过该密码申诉')
let source = localStorage.getItem('school_source') || '' 
if (source === 'v1') {
this.$router.push({ path: '/todoPage' })
} else if (source === 'v2') {
this.$router.push({ path: '/v2todoPage' })
}
} else {
this.$vux.toast.show({
type: 'warn',
text: res.result.msg || res.result
})
this.isConfirmshow = false
}
}).catch(error => {
console.log(error)
})
} else {
this.$http({
method: 'post',
url: '/workorder/loginPwdAppeal/rejectcheck',
params: params
}).then(res => {
if (res.success) {
this.$vux.toast.text('操作成功，已拒绝该密码申诉')
let source = localStorage.getItem('school_source') || '' 
if (source === 'v1') {
this.$router.push({ path: '/todoPage' })
} else if (source === 'v2') {
this.$router.push({ path: '/v2todoPage' })
}
} else {
this.$vux.toast.show({
type: 'warn',
text: res.result.msg || res.result
})
this.isConfirmshow = false
}
}).catch(error => {
console.log(error)
})
}
}
}
}




// WEBPACK FOOTER //
// ./src/components/handleReply/handleReply.vue